module.exports = __webpack_public_path__ + "img/huangyong.b36d6e80.jpg";